import type { Route } from '../../routes/types';
import { Agenda } from './Agenda';
import { Cuenta } from './Cuenta';
import { Metricas } from './Metricas';
import { FichaPaciente, Pacientes } from './Pacientes';
import { Perfil } from './Perfil';
import { Recordatorios } from './Recordatorios';
import { Servicios } from './Servicios';
import { TurnoDelProfesional } from './TurnoDelProfesional';
import { Turnos } from './Turnos';
import './profesional.css';

const soloProfesionales = { roles: ['profesional' as const], layout: 'panel-profesional' as const };

export const routes: Route[] = [
  { path: '/pro/agenda', title: 'Agenda', screen: Agenda, ...soloProfesionales },
  { path: '/pro/turnos', title: 'Turnos', screen: Turnos, ...soloProfesionales },
  { path: '/pro/turno/:id', title: 'Detalle del turno', screen: TurnoDelProfesional, ...soloProfesionales },
  { path: '/pro/pacientes', title: 'Pacientes', screen: Pacientes, ...soloProfesionales },
  { path: '/pro/paciente/:id', title: 'Ficha del paciente', screen: FichaPaciente, ...soloProfesionales },
  { path: '/pro/metricas', title: 'Métricas', screen: Metricas, ...soloProfesionales },
  { path: '/pro/perfil', title: 'Mi perfil', screen: Perfil, ...soloProfesionales },
  { path: '/pro/servicios', title: 'Servicios y horarios', screen: Servicios, ...soloProfesionales },
  { path: '/pro/whatsapp', title: 'Recordatorios', screen: Recordatorios, ...soloProfesionales },
  { path: '/pro/cuenta', title: 'Cuenta y plan', screen: Cuenta, ...soloProfesionales },
];
